export const pageCreation = (page, pSize) =>{
    const pageSize = pSize ? pSize : 30;
        let startIndex = (pageSize * (page - 1)) + 1;
        let endIndex = pageSize * (page - 1) + pageSize;
    return {startIndex,endIndex}
}